import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { injectIntl } from "react-intl";
import { createSelector } from 'reselect';

import DependencyDialogComponent from './DependencyDialog';
import { deleteModifier, getModifierDependencies, setModifierDepdendencyDialog, modifierReset, createEditReset } from '../../../store/actions/modifiers';


export const DependencyDialog = connect(
    () => {
        const selectDependencyDialog = (state) => state.modifiers.dependencyDialog;

        const selectOpen = createSelector(
            selectDependencyDialog,
            (claimDependencyDialog) => {
                if (claimDependencyDialog && claimDependencyDialog?.open) {
                    return true
                }
                return false
            }
        );

        const selectModifierId = createSelector(
            selectDependencyDialog,
            (claimDependencyDialog) => {
                if (claimDependencyDialog && claimDependencyDialog?.modifierId) {
                    return claimDependencyDialog?.modifierId
                }
                return null
            }
        );

        const selectModifierName = createSelector(
            selectDependencyDialog,
            (claimDependencyDialog) => {
                if (claimDependencyDialog && claimDependencyDialog?.modifierName) {
                    return claimDependencyDialog?.modifierName
                }
                return ''
            }
        );

        return (state, props) => ({
            open: selectOpen(state),
            modifierId: selectModifierId(state, props),
            modifierDependencies: state.modifiers.dependencies,
            modifierDependencyPending: state.modifiers.getModifierDependencies.pending,
            modifierDeletePending: state.modifiers.deleteModifier?.pending,
            modifierName: selectModifierName(state)
        });
    },
    (dispatch) => ({
        actions: bindActionCreators({
            setModifierDepdendencyDialog: setModifierDepdendencyDialog,
            getModifierDependencies: getModifierDependencies,
            deleteModifier: deleteModifier,
            resetModifierItems: createEditReset
        }, dispatch)
    })
)(injectIntl(DependencyDialogComponent));